(() => {
  'use strict';

  const contentSelector = '[data-enchliving-media-grid-variant-image-content]';
  const productTemplateSelector = '[data-enchliving-media-grid-product-image-template]';

  function updateZoomSource(image) {
    const zoomContainer = image.closest('.zoom_container');

    if (!image || !zoomContainer) return;

    const source = image.currentSrc || image.src;

    if (source) {
      zoomContainer.style.setProperty('--url', `url(${source})`);
    }
  }

  function updateMediaGridImages(variantId) {
    document.querySelectorAll(contentSelector).forEach((image) => {
      const mediaItem = image.closest('.media-grid__item') || document;
      const variantTemplate = variantId
        ? mediaItem.querySelector(`[data-enchliving-media-grid-variant-image-template="${variantId}"]`)
        : null;
      const productTemplate = mediaItem.querySelector(productTemplateSelector);
      const template = variantTemplate || productTemplate;

      if (!template) return;

      const nextImage = template.content.firstElementChild?.cloneNode(true);

      if (!nextImage) return;

      image.replaceWith(nextImage);
      updateZoomSource(nextImage);
    });
  }

  document.addEventListener('variant:change', (event) => {
    updateMediaGridImages(event.detail?.variant?.id);
  });
})();
